<div *ngIf="hasFilter" class="eui-menu-filter" (click)="onMenuFilterClick($event)">
    <div class="eui-clearable-input-wrapper">
        <input type="text" #input (keyup)="onFilter(input.value)" class="eui-menu-filter__input" placeholder="{{searchFilterLabel}}" [attr.aria-label]="searchFilterLabel" />
        <span class="eui-menu-filter__search-icon eui-icon eui-icon-search-m" aria-label="Search Icon"></span>
        <span class="eui-clearable-input-wrapper__clear" *ngIf="input.value" (click)="onClearInput()" aria-label="Clear"></span>
    </div>
</div>

<ul class="eui-menu" role="menubar">
    <span *ngIf="!items" class="eui-menu--no-items">No menu items defined</span>
    <ng-container *ngFor="let item of items; let i = index">
            <eui-menu-item *ngIf="item.filtered" [item]="item" [hasIcon]="hasIcons" [hasTooltip]="hasTooltip" [isCollapsed]="isCollapsed"
                           (expandToggled)="onExpandToggle($event)" (clicked)="onClick($event)">
                <ul *ngIf="item.children && item.expanded" class="eui-menu eui-menu-sub" role="menu" aria-haspopup="true" aria-expanded="true">
                    <ng-container *ngFor="let itemSub of item.children; let isub = index">
                        <eui-menu-item [item]="itemSub" [hasIcon]="hasIcons" [hasTooltip]="hasTooltip" [isCollapsed]="isCollapsed"
                                       (expandToggled)="onExpandToggle($event)" (clicked)="onClick($event)">
                            <ul *ngIf="itemSub.children && itemSub.expanded" class="eui-menu eui-menu-sub" role="menu" aria-haspopup="true" aria-expanded="true">
                                <ng-container *ngFor="let itemSubSub of itemSub.children; let isubub = index">
                                    <eui-menu-item [item]="itemSubSub" [hasIcon]="hasIcons" [hasTooltip]="hasTooltip" [isCollapsed]="isCollapsed"
                                                   (expandToggled)="onExpandToggle($event)" (clicked)="onClick($event)">
                                    </eui-menu-item>
                                </ng-container>
                            </ul>
                        </eui-menu-item>
                    </ng-container>
                </ul>
            </eui-menu-item>
    </ng-container>
</ul>
